module.exports = __webpack_public_path__ + "img/255.fe29694c.jpg";